/**
 * <s-help-theme> — Help Center light / dark toggle.
 *
 * The inline script in layout/theme.liquid sets <html data-help-theme> before
 * first paint on Help Center templates (stored choice, else dark, merchant 2026-10-29). This
 * element flips it on click, saves the choice in localStorage and keeps every
 * toggle on the page (sidebar + mobile bar) in sync.
 */
const KEY = 'the4-help-theme';

class SHelpTheme extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    const button = this.querySelector('button');
    if (!button) return;
    this.#sync();
    button.addEventListener('click', () => {
      const next = document.documentElement.dataset.helpTheme === 'dark' ? 'light' : 'dark';
      document.documentElement.dataset.helpTheme = next;
      try { localStorage.setItem(KEY, next); } catch { /* private mode */ }
      document.dispatchEvent(new CustomEvent('help-theme:change'));
    }, { signal: this.#ac.signal });
    document.addEventListener('help-theme:change', () => this.#sync(), { signal: this.#ac.signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #sync() {
    const button = this.querySelector('button');
    const dark = document.documentElement.dataset.helpTheme === 'dark';
    button.setAttribute('aria-pressed', String(dark));
    button.setAttribute('aria-label', dark ? button.dataset.labelLight : button.dataset.labelDark);
  }
}

if (!customElements.get('s-help-theme')) customElements.define('s-help-theme', SHelpTheme);
